webpackJsonp([149238044499135],{

/***/ 1358:
/***/ (function(module, exports) {

	module.exports = {"data":{"allBlogJson":{"edges":[{"node":{"title":"Quick intro to Gulp.js","metaDescription":"Looking for resources as you learn to code? The Code Fellows blog features helpful tutorials, alumni stories, student projects, school news, and more!","slug":"blog/quick-intro-to-gulp-js","createdAt":"2014-01-23T23:47:04.482Z","blogAuthor":{"fields":{"name":"Jake Chapman","slug":"blog/author/jake-chapman"}},"imageHeader":{"fields":{"file":{"url":"//images.ctfassets.net/k428n7s2pxlu/3cMwawZL56syqm4gEwgAYA/bb144aa578aa258d9e12303b49daf006/blog-post-blog-quick-intro-to-gulp-js.jpg"}}}}}]},"authorJson":{"name":"Jake Chapman","slug":"blog/author/jake-chapman","twitter":null,"linkedIn":null,"website":null,"biography":null,"image":null}},"pathContext":{"slug":"blog/author/jake-chapman"}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-author-jake-chapman-733abe15555cee3e922e.js